import React, { useState, useEffect } from "react";
import axios from "axios";
import { EqNotificationActivityType, EqNotificationType } from "../../components/shared/enums";
import Api from "../../components/shared/Api";
import { useAuthState } from "../../components/context/Context";
import { ValidateIsUser } from "../../components/shared/Common";
import { useTranslation } from "react-i18next";
import { Popover } from "antd";
import { Badge, Col, Row, Space } from "antd-v5";
import { BellFilled } from "@ant-design/icons";
import "./NotificationSection.scss";
import EtTag from "../eqCustom/EtTag/EtTag";
import NotificationItem from "../NotificationItem/NotificationItem";

 export interface INotificationItem {
    id: string;
    senderId: string;
    senderName: string;
    receiverId: string;
    receiverName: string;
    titleTemplate: string;
    messageTemplate: string;
    redirectUrl: string;
    notificationType: EqNotificationType;
    activityType: EqNotificationActivityType;
    activityName: string;
    isRead: boolean;
    createdOn: number;
}

const NotificationSection = () => {
    const userDetails: any = useAuthState();
    const isValidUser: boolean = ValidateIsUser(userDetails);
    const { t, i18n } = useTranslation();

    const [notifications, setNotifications] = useState<INotificationItem[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [unReadCount, setUnReadCount] = useState(0);

    useEffect(() => {
        if (isValidUser) fetchNotifications();
    }, []);

    const fetchNotifications = async () => {
        try {
            const response = await Api.get("/api/NotificationMessage");

            if (response.data) {
                setNotifications(response.data);
                
                let unReadCount = response.data.filter(
                    (notification: INotificationItem) => !notification.isRead
                );
                setUnReadCount(unReadCount.length);
            }
// Sort: Unread notifications first, then sort by createdOn (descending)
const sortedNotifications = response.data.sort((a: INotificationItem, b: INotificationItem) => {
    if (a.isRead === b.isRead) {
        return b.createdOn - a.createdOn; // Sort by createdOn (newest first)
    }
    return a.isRead ? 1 : -1; // Unread notifications first
});

            setNotifications(sortedNotifications);
        } catch (error: any) {
            setError(error.message);
        }
    };
    const handleOnClickNotification = async (notification: INotificationItem) => {
        // Handle notification click and mark it as read
        if (!notification.isRead) {
            try {
                const response = await Api.put(`/api/NotificationMessage/mark-as-read/${notification.id}`);
                if (response.status === 200) {
                    // Update the specific notification as read in the notifications state
                    const updatedNotifications = notifications.map((n) =>
                        n.id === notification.id ? { ...n, isRead: true } : n
                    );
                    let unReadCount = updatedNotifications.filter(
                        (notification: INotificationItem) => !notification.isRead
                    ).length;
                    setNotifications(updatedNotifications);
    
                    // Decrement unread count
                    setUnReadCount(unReadCount - 1);
                }
            } catch (error) {
                console.error("Error marking notification as read:", error);
            }
        }
    };
    



    return (
        <div className="notification-section">
            <Popover
                className="notification-popover"
                trigger={"click"}
                content={
                    <div className="notification-popover-content">
                        <h3>Notifications</h3>

                        {notifications?.map((notification) => (

                                <NotificationItem
                                key={notification.id}
                                notification={notification}
                                onClick={handleOnClickNotification}
                                />
              
                        ))}
                    </div>
                }
            >
                <Row
                    className="notification-section-bar"
                    onClick={() => {
                        // setShowCount(true);
                        setUnReadCount(0);
                    }}
                >
                    <Space>
                        <Col>
                            <BellFilled
                                style={{ fontSize: "17px", color: "#ff8838" }}
                                onClick={() => {
                                    setUnReadCount(0);
                                }}
                            />
                        </Col>
                        <Col>{t("notifications")}</Col>
                        <Col>
                            <Badge
                                size="small"
                                count={unReadCount}
                                // dot={showCount}
                            ></Badge>
                        </Col>
                    </Space>
                </Row>
            </Popover>
        </div>
    );
};

export default NotificationSection;
